import { SearchImpressionRegistry } from './search-impression-registry';

// One registry for everything a results page reports impressions for — the result rows and
// the Panda answer card — so a context change rolls all of it over in one place.
export const searchImpressions = new SearchImpressionRegistry();

let lastContextId: string | undefined;

/**
 * Roll the registry over when the search context changes. Call it during render, before
 * resolving ids — a reset that lands late, in an effect, can wipe an id a child has already
 * reported. An empty context is "no context", not a new one: losing the context between
 * searches must not make the registry forget what it has already reported.
 */
export function syncSearchImpressionContext(contextId?: string): void {
  if (contextId && contextId !== lastContextId) {
    searchImpressions.reset();
    lastContextId = contextId;
  }
}
